import React from 'react';
import PropTypes from 'prop-types';
import {IntlProvider} from 'react-intl';

import {connect} from '@stubhub/react-store-provider';

import controller from './controller';
import DesktopDefaultConfigData from './defaultConfigConstants/defaultDesktop';
import MobileDefaultConfigData from './defaultConfigConstants/defaultMobile';
import BYODesktopMapConfigData from './mapbox-constants/byo_desktop_config_constants';
import BYOMobileMapConfigData from './mapbox-constants/byo_mobile_config_constants';
import DesktopMapConfigData from './mapbox-constants/desktop_config_constants';
import MobileMapConfigData from './mapbox-constants/mobile_config_constants';
import SeatMapState from './SeatMapState';

class MapboxVoidSSR {}
const mapboxgl = __CLIENT__ ? require('mapbox-gl') : {Popup: MapboxVoidSSR};

const configByDevice = {
  phone: MobileMapConfigData,
  desktop: DesktopMapConfigData,
};

const defaultConfigByDevice = {
  phone: MobileDefaultConfigData,
  desktop: DesktopDefaultConfigData,
};

@connect(controller)
export default class SeatMapWrapper extends React.Component {
  constructor(props) {
    super(props);
  }

  static contextTypes = {
    globalRegistry: PropTypes.object,
    router: PropTypes.object,
  };

  render() {
    if (!mapboxgl?.supported?.()) {
      return null;
    }

    const {listingInfo, device, venueConfigId} = this.props;

    let defaultConfig = defaultConfigByDevice[device] || defaultConfigByDevice.desktop;
    let mapConfigData = configByDevice[device] || configByDevice.desktop;

    if (listingInfo) {
      if (device === 'desktop' || device === 'tablet') {
        mapConfigData = {...mapConfigData, ...BYODesktopMapConfigData};
      } else if (device === 'phone') {
        mapConfigData = {...mapConfigData, ...BYOMobileMapConfigData};
        defaultConfig = {...defaultConfig};
        defaultConfig.center = BYOMobileMapConfigData.MAP_INITAL_CENTER;
      }
    }

    if (!venueConfigId) {
      return null;
    }

    return (
      <IntlProvider>
        <SeatMapState
          {...this.props}
          mapInstanceWrapperRef={(mapInstance) => (this.mapInstance = mapInstance)}
          wrapperMapActions={(actions) => (this.wrapperActions = actions)}
          seatMapsWrapperActions={(actions) => (this.seatMapsWrapperActions = actions)}
          mapInstance={this.mapInstance}
          actions={this.wrapperActions}
          seatMapActions={this.seatMapsWrapperActions}
          mapConfigData={mapConfigData}
          defaultConfig={defaultConfig}
        />
      </IntlProvider>
    );
  }
}

SeatMapWrapper.propTypes = {
  /** The device type. */
  device: PropTypes.string,

  /** The listing info. */
  listingInfo: PropTypes.object,

  /** The venue config ID. */
  venueConfigId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
